import { Card, Divider, Flex } from 'antd'
import { useTheme } from 'antd-style'

import {
  InternalInquiryDocumentResponse,
  InternalIssuanceDocumentResponse
} from 'src/api/requests'
import { Text } from 'src/components'
import { useStyles } from 'src/features/stock/components/styles'
import { useLocales } from 'src/locales'

type Props = {
  data?: InternalInquiryDocumentResponse
  issuanceData?: InternalIssuanceDocumentResponse
}

export const LocalApplicationCommentSection = ({
  data,
  issuanceData
}: Props) => {
  const { t } = useLocales()

  const palette = useTheme()

  const { styles } = useStyles()

  return (
    (data?.comment || issuanceData?.comment) && (
      <Card title={t('common.comment')} className={styles.commentCardWrapper}>
        <Flex vertical gap={8} className={styles.commentCard}>
          {data?.comment && (
            <>
              <Text size="lg">{t('stock_applications.beneficiary')}</Text>

              <div className={styles.commentBeneficiary}>{data?.comment}</div>
              <Text size="lg" color={palette.colorTextTertiary}>
                {data?.commentBy?.firstName} {data?.commentBy?.lastName} -{' '}
                {data?.role?.name}
              </Text>
            </>
          )}
        </Flex>
        {issuanceData?.comment && (
          <>
            <Divider className={styles.commentDivider} />
            <Flex vertical gap={8} className={styles.commentCard}>
              <Text size="lg">{t('stock_applications.beneficiary')}</Text>
              <div className={styles.commentBeneficiary}>
                {issuanceData?.comment}
              </div>
              <Text size="lg" color={palette.colorTextTertiary}>
                {issuanceData?.commentBy?.firstName}{' '}
                {issuanceData?.commentBy?.lastName} - {issuanceData?.role?.name}
              </Text>
            </Flex>
          </>
        )}
      </Card>
    )
  )
}
